import * as React from 'react';
export function useFinger() {
  const touchId = React.useRef(null);
  function getFinger(event) {
    if ('changedTouches' in event) {
      if (touchId.current !== null) {
        for (let i = 0; i < event.changedTouches.length; i++) {
          const touch = event.changedTouches[i];
          if (touch.identifier === touchId.current) {
            return {
              x: touch.clientX,
              y: touch.clientY
            };
          }
        }
      }
      return null;
    }
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  function setFinger(event) {
    touchId.current = event && event.changedTouches[0].identifier;
  }
  return [getFinger, setFinger];
}